import asyncSessionLoader from "../../../../../../core/gd/data/async-session-loader"
import ProjectSession from "../../../../../../core/model2/project/project-session"

type APICallParams = {
    parentProject?  : ID
    name            : string
    owner?          : string
    color?          : number
    defaultView?    : ID
}

const debug = false
// const debug = 'quickAdd_createFolder'

export default async function quickAdd_createFolder(params: APICallParams, isEmpty: boolean = false) {

    await asyncSessionLoader(gd.session.findMissing({
        // @ts-ignore
        projectsSettings: [params.parentProject, ...gd.session.projects.getAllParentsIds(params.parentProject)]
    }))

    // create project for Folder
    const data = await gd.api.Project.newWorkfolder({
        company         : gd.companyId,
        parentProject   : params.parentProject,
        name            : params.name,
        shortName       : gd.utils.generateShortName(params.name),
        owner           : params.owner,
        color           : params.color,
        defaultView     : params.defaultView
    }).promise()

    // load settings of just created project
    await asyncSessionLoader(gd.session.findMissing({
        projectsSettings: [data.projectId],
    }))

    const project: ProjectSession = gd.session.projects.get(data.projectId)!
    debug && console.log(debug, 'onSubmit project', project.settings)

    if (isEmpty && project.settings) {
        // add empty views to settings
        project.settings.views = []
        await project.settings.save()
    }

    return project
}